import React, { ButtonHTMLAttributes } from 'react';
import * as Styled from './styles';

export const UnstyledButton: React.FC<ButtonHTMLAttributes<
  HTMLButtonElement
>> = ({ children, ...props }) => {
  return <Styled.UnstyledButton {...props}>{children}</Styled.UnstyledButton>;
};
